module.exports = __webpack_public_path__ + "img/dia_spaceBg.c4726c58.jpg";